/* global modForm */
export function showUtilityProviders(skipStep, utilityProviders) {
	const $utilityProviderWrapper = modForm.opts.form.querySelector('[name="UtilityProvider"]');
	const $utilityProviderStep = $utilityProviderWrapper?.closest(modForm.opts.stepsSelector);

	// Short circuit out of this method if we don't need to create the util provider DOM again
	if (JSON.stringify(utilityProviders) === JSON.stringify(modForm.oldUtilProviders)) {
		return;
	}

	$utilityProviderWrapper.innerHTML = '';
	modForm.oldUtilProviders = utilityProviders;
	const $defaultOption = document.createElement('option');
	$defaultOption.value = '';
	$defaultOption.textContent = 'Select an option';
	$utilityProviderWrapper.appendChild($defaultOption);

	$utilityProviderStep?.toggleAttribute('data-hide-step', skipStep);

	// Iterate over utilityProviders and append each as an option
	utilityProviders.forEach((provider, i) => {
		const utilityProviderName = provider.name;
		const $option = document.createElement('option');
		$option.textContent = utilityProviderName;
		if (i === 0 && skipStep) {
			$option.setAttribute('selected', 'selected');
		}
		$utilityProviderWrapper.appendChild($option);
	});
}
